import { styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { RateChildrenCountBadge } from "@sinch/components/application/RatelistBuilder/RateTreeItem/styled";

interface ExpandButtonProps {
  /** Number of child items to display in the badge */
  childrenCount: number;
  /** Whether the expansion is currently pending */
  loading: boolean;
  /** Callback function to handle item expansion */
  onClick: (e: React.SyntheticEvent) => void;
}

/**
 * Button component that shows children count and allows expanding collapsed tree items
 */
export const ExpandButton: React.FC<ExpandButtonProps> = ({ childrenCount, loading, onClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <RateChildrenCountBadge>{childrenCount}</RateChildrenCountBadge>
      <ExpandButtonText onClick={onClick} variant="overline">
        {loading ? `${t("loading")}...` : t("more")}
      </ExpandButtonText>
    </>
  );
};
const ExpandButtonText = styled(Typography)(({ theme }) => ({
  fontSize: `${11 / 16}rem`,
  fontWeight: "600",
  color: theme.palette.grey[600],
  paddingLeft: theme.spacing(1),
  cursor: "pointer",
}));
